// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"760":"a8063d17","942":"7e3b72c0"}[chunkId] + ".chunk.js";
};